/* eslint-disable react-hooks/rules-of-hooks */
import { useState, createContext, useEffect, useCallback, useContext } from 'react';
import { semaforo } from '@victorequena22/utiles';
import { LandingUpdate, conLanding } from '../../../../Panel/Models/Landing';
import { Panel } from '../../../../Panel/Models';
import { getPrograma } from '../index';
import { getEventos } from '../../../Context/Eventos';
export interface LandingType {
    panels: Panel[];
    actualizar: () => void;
}
export const LandingContext = createContext<LandingType>({ panels: [], actualizar: () => { } })
export default function LandingProvider({ children }: { children: any }) {
    const { id: i } = getPrograma();
    const id = getEventoID(i);
    const [panels, setPanels] = useState<Panel[]>([]);
    const [con] = useState(conLanding());
    const actualizar = useCallback(() => LandingUpdate(con, 'evento', id, panels, setPanels), [con, id, panels]);
    useEffect(() => { let interval = setInterval(actualizar, 50); return () => clearInterval(interval); }, [actualizar]);
    useEffect(() => { const s = semaforo(); s.add('Landing'); return () => s.clean('Landing'); }, []);
    return <LandingContext.Provider value={{ panels, actualizar }}>{children}</LandingContext.Provider>
}
export const SeccionConsumer = LandingContext.Consumer;
// eslint-disable-next-line react-hooks/rules-of-hooks
export const useLanding = () => useContext(LandingContext);

export const getEventoID = (id: number) => {
    const e = getEventos().filter(e => e.programa === id);
    if (e.length === 0) return -1;
    return e[Math.floor(Math.random() * e.length)].id;
}